import { render, staticRenderFns } from "./systemMessageDetail.vue?vue&type=template&id=4366755a&scoped=true"
import script from "./systemMessageDetail.vue?vue&type=script&lang=js"
export * from "./systemMessageDetail.vue?vue&type=script&lang=js"
import style0 from "./systemMessageDetail.vue?vue&type=style&index=0&id=4366755a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4366755a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4366755a')) {
      api.createRecord('4366755a', component.options)
    } else {
      api.reload('4366755a', component.options)
    }
    module.hot.accept("./systemMessageDetail.vue?vue&type=template&id=4366755a&scoped=true", function () {
      api.rerender('4366755a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notify/messageLog/systemMessageDetail.vue"
export default component.exports